import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { AccountItem } from "./AccountItem";
import { AccountLink } from "./AccountLink";
import * as styles from "./AccountPopover.styles";
import { FAVOURITES_PAGE_HREF } from "../../../constants/hrefs";
export var AuthenticatedAccountLinks = function AuthenticatedAccountLinks(_ref) {
  var includeFavourites = _ref.includeFavourites,
    _ref$member = _ref.member,
    member = _ref$member === void 0 ? false : _ref$member;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.sections
  }, member && /*#__PURE__*/React.createElement(_StyledSection, {
    $_css2: styles.membershipSection
  }, /*#__PURE__*/React.createElement(AccountItem, {
    text: "NOTHS & More Member"
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(_StyledUl, {
    $_css3: styles.list
  }, includeFavourites && /*#__PURE__*/React.createElement(_StyledLi, {
    $_css4: styles.smallScreensOnly
  }, /*#__PURE__*/React.createElement(AccountLink, {
    href: FAVOURITES_PAGE_HREF,
    text: "My Favourites"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(AccountLink, {
    href: "/user/orders",
    text: "My Orders"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(AccountLink, {
    href: "/user",
    text: "My Details"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(AccountLink, {
    href: "/u/password/new",
    text: "My Password"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(AccountLink, {
    href: "/user/account",
    text: "My Funds"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(AccountLink, {
    href: "/u/marketing-preferences",
    text: "My Marketing Preferences"
  })))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(AccountLink, {
    href: "/u/sign-out",
    text: "Sign out"
  })));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSection = _styled2("section")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledUl = _styled3("ul")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledLi = /*#__PURE__*/_styled4("li").withConfig({
  displayName: "AuthenticatedAccountLinks___StyledLi",
  componentId: "sc-es2t5t-0"
})(["", ""], function (p) {
  return p.$_css4;
});